import { render } from "./Master.vue?vue&type=template&id=2e3caa6f&ts=true"
import script from "./Master.vue?vue&type=script&lang=ts"
export * from "./Master.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__